import React, {
  createContext,
  useState,
  useEffect,
  useContext,
  useCallback,
} from "react";
import { useNavigate } from "react-router-dom";
import { refreshToken, clearCache } from "../api/bitbucketApi";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  const logout = useCallback(() => {
    localStorage.removeItem("bitbucket_token");
    localStorage.removeItem("bitbucket_refresh_token");
    localStorage.removeItem("bitbucket_token_expiry");
    clearCache();
    setIsAuthenticated(false);
    setUser(null);
    navigate("/login");
  }, [navigate]);

  // Check if user is authenticated on initial load
  useEffect(() => {
    const checkAuth = async () => {
      const token = localStorage.getItem("bitbucket_token");
      const tokenExpiry = localStorage.getItem("bitbucket_token_expiry");

      if (!token) {
        setIsLoading(false);
        return;
      }

      // Check if token is expired or about to expire (within 5 minutes)
      if (tokenExpiry && Date.now() > Number(tokenExpiry) - 5 * 60 * 1000) {
        try {
          await refreshToken();
        } catch (error) {
          logout();
          setIsLoading(false);
          return;
        }
      }

      setIsAuthenticated(true);
      setIsLoading(false);
    };

    checkAuth();
  }, [logout]);

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        isLoading,
        user,
        setUser,
        setIsAuthenticated,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);

export default AuthContext;
